<template>
  <aside
    :class="[
      'ecx-sidebar',
      'flex shrink-0 flex-col bg-white border-r border-border-gray py-2 relative overflow-visible',
      'transition-[width,padding-left,padding-right] duration-300 ease-out',
      expanded ? 'w-72 px-8' : 'w-24 px-2',
    ]"
    :aria-expanded="expanded"
  >
    <!-- Linha vertical que sobe até o topo (complementa a border-r no header) -->
    <div class="absolute top-0 right-0 w-px bg-border-gray" style="height: calc(100% + 8px); transform: translateY(-8px);" />

    <!-- Header / Logo Area -->
    <div class="ecx-sidebar-header relative" :class="expanded ? '-mx-8' : '-mx-2'">
      <!-- Linha horizontal abaixo da logo que se conecta com a borda da toolbar -->
      <div class="absolute -bottom-2 left-0 h-px bg-border-gray" style="right: -1px;" />
      
      <div :class="['flex items-center justify-center', expanded ? 'px-8' : 'px-6']">
        <slot name="logo" :expanded="expanded">
          <!-- Logo padrão se não houver slot -->
          <div class="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-lg">E</span>
          </div>
        </slot>
      </div>
    </div>

    <!-- Navigation Area -->
    <nav
      :class="[
        'ecx-sidebar-nav flex-1 flex flex-col gap-y-4 pt-6 overflow-y-auto w-full',
        expanded ? 'items-stretch' : 'items-center',
      ]"
    >
      <slot :expanded="expanded" />
    </nav>

    <!-- Footer Area (optional) -->
    <div v-if="$slots.footer" class="ecx-sidebar-footer">
      <slot name="footer" :expanded="expanded" />
    </div>
  </aside>
</template>

<script setup lang="ts">
export interface SidebarProps {
  /** Se a sidebar está expandida */
  expanded?: boolean
}

withDefaults(defineProps<SidebarProps>(), {
  expanded: true,
})

// Expor o estado para uso externo
defineExpose({
  // Métodos ou refs que queira expor
})
</script>

<style scoped>
.ecx-sidebar {
  min-height: 100vh;
  height: 100%;
}

.ecx-sidebar-nav {
  scrollbar-width: thin;
  scrollbar-color: var(--border-gray, #e5e7eb) transparent;
}

.ecx-sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.ecx-sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.ecx-sidebar-nav::-webkit-scrollbar-thumb {
  background-color: var(--border-gray, #e5e7eb);
  border-radius: 4px;
}
</style>

